import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import Grid from '@mui/material/Grid2';
import TitleDescription from "../components/TitleDescription";
import Title from "../components/Title";
import TitleDescriptionImage from "../components/TitleDescriptionImage";
import { ReactComponent as ComprehensiveAnalyticsReportingComponent } from "../assets/comprehensive-analytics-reporting.svg"
import { ReactComponent as SeamlessIntegrationWithCBSComponent } from "../assets/seamless-integration-with-cbs.svg"
import { ReactComponent as SeamlessSupport247Component } from "../assets/247-support.svg"
import { ReactComponent as RiskGaugeComponent } from "../assets/riskguage.svg"
import { useLocation } from "react-router-dom";
import { fetchAndFilterOpenAPISpec } from "../utils/openapi-filter";

function navigateToSection(hash: string) {
    const element = document.getElementById(hash);
    if (element) {
        var headerOffset = 45;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
}

const RiskGaugePage: React.FC = React.memo(() => {
    const rapidocRef = useRef<any>(null);
    const location = useLocation();
    useEffect(() => {
        if (location.hash.length === 0) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            return;
        }

        const hash = location.hash.slice(1);
        navigateToSection(hash);
    }, [location.hash]);


    useEffect(() => {
        const loadFilteredSpec = async () => {
            if (rapidocRef.current) {
                try {
                    const filteredSpec = await fetchAndFilterOpenAPISpec({
                        specUrl: 'https://dhanaprayoga.fiu.finfactor.in/risk-gauge-internal/v1/openapi',
                        includePaths: [
                            '/risk-gauge/api/v1/data*',
                        ]
                    });

                    rapidocRef.current.loadSpec(filteredSpec);
                } catch (error) {
                    console.error('Failed to load API spec:', error);
                }
            }
        };

        loadFilteredSpec();
    }, []);

    return <>
        <Box sx={{
            paddingLeft: 4
        }}>
            <TitleDescription title="Risk Gauge" description="Your Bank Statement Analyser for accurate and low-cost credit decisioning." />
            <>
                <Title title="Why Risk Gauge?" />
                <Grid container spacing={3} paddingTop={1}>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="Intelligent Underwriting Insights"
                            description="Accurately identify income, obligations, frauds along with UPI transaction categorisations to assess customer's financial health."
                            svg={ComprehensiveAnalyticsReportingComponent}
                            maxWidth={290}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="Multiple data sources"
                            description="Supports multiple data fetch flows like AA and PDF statement upload."
                            svg={SeamlessIntegrationWithCBSComponent}
                            maxWidth={290}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="Customise as per your needs"
                            description="Ability to add additional insights to assist your decision making"
                            svg={SeamlessSupport247Component}
                            maxWidth={290}
                        />
                    </Grid>
                </Grid>
            </>
        </Box>
        <Box sx={{
            paddingLeft: 4
        }}>
            <>
                <Title title="How Risk Gauge Works - Sequence Diagram" paddingBottom={4} paddingTop={6} />
                <RiskGaugeComponent />
            </>
        </Box>
        <rapi-doc
            ref={rapidocRef}
            allow-try={true}
            allow-authentication={false}
            spec-url={""}
            show-info={false}
            show-header={false}
            render-style="view"
            primary-color="#4D2FA3"
            bg-color="#FAFBFC"
            schema-style="table"
            allow-server-selection={false}
            server-url={"https://dhanaprayoga.fiu.finfactor.in/"}
            regular-font='"Roboto","Helvetica","Arial",sans-serif'
            mono-font='"Roboto","Helvetica","Arial",sans-serif'
            schema-description-expanded={true}
        ></rapi-doc>
    </>
});

export default RiskGaugePage;
